import { render } from "./MetodosPagoView.vue?vue&type=template&id=6f23e727&scoped=true"
import script from "./MetodosPagoView.vue?vue&type=script&lang=js"
export * from "./MetodosPagoView.vue?vue&type=script&lang=js"

import "./MetodosPagoView.vue?vue&type=style&index=0&id=6f23e727&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f23e727"]])

export default __exports__